import React from 'react';
import momentTZ from 'moment-timezone';
import { Datagrid, FunctionField, List, SelectField, TextField } from 'react-admin';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';
import { timeZones } from '../../../../config/constants';
import { BADGE_TIER_CHOICES, DATE_TIME_FIELD_FORMAT } from '../config/constants';
import AchievementSystemReportsFilter from './AchievementSystemReportsFilter';

const appTimeZone = timeZones[process.env.REACT_APP_APP_TYPE];

const renderCompletedAt = ({ completed_at }) =>
  completed_at ? momentTZ(completed_at).tz(appTimeZone).format(DATE_TIME_FIELD_FORMAT) : '';

const AchievementSystemReportsList = (props) => (
  <List
    title="Achievement system reports"
    actions={<CustomReportListActions />}
    filters={<AchievementSystemReportsFilter />}
    bulkActionButtons={false}
    sort={{ field: 'completed_at', order: 'DESC' }}
    {...props}
  >
    <Datagrid>
      <TextField label="User ID" source="user_id" />
      <TextField label="Badge name" source="badge_name" />
      <SelectField label="Badge tier" source="badge_tier" choices={BADGE_TIER_CHOICES} />
      <FunctionField label="Completion date" source="completed_at" render={renderCompletedAt} />
    </Datagrid>
  </List>
);

export default AchievementSystemReportsList;
